import IntroLine from "./IntroLine";

export { IntroLine };
export default IntroLine;
